module.exports = __webpack_public_path__ + "static/media/YF107_4.66154674.jpg";